export const APPLICANT = 'Applicant';
export const PRE_SCREEN = 'Pre-screen';
export const CLIENT_REVIEW = 'Client Review';
export const INTERVIEW = 'Interview';
export const OFFER_EXTENDED = 'Offer Extended';
export const OFFER_SUBMITTED = 'Offer Submitted';
export const OFFER_REJECTED = 'Offer Rejected';
export const OFFER_ACCEPTED = 'Offer Accepted';
export const REJECTED = 'Rejected';
export const ONBOARDING_PREP = 'Onboarding Prep';
export const ONBOARDING_FINAL = 'Onboarding Final';
export const PLACED = 'Placed';
export const BACKED_OUT = 'Backed Out';

export const APPROVED = 'Approved';
export const REJECT = 'Reject';
export const RESTORE = 'Restore';
export const WITHDRAWN = 'Withdrawn';
export const PENDING_INTERVIEW = 'Pending Interview';
export const MSP_CAPS_REVIEW = 'MSP Review';
export const MSP_REVIEW = 'Msp Review';
export const APPROVE = 'Approve';
export const INVITE_TO_WORKSPACE = 'Approve for Client';
export const REJECT_FROM_WORKSPACE = 'Reject from Client';

export const RejectedCandidateStatus = [REJECTED];

export const CandidateStatus = [
  APPLICANT,
  PRE_SCREEN,
  CLIENT_REVIEW,
  INTERVIEW,
  OFFER_EXTENDED,
  OFFER_SUBMITTED,
  OFFER_REJECTED,
  OFFER_ACCEPTED,
  REJECTED,
  BACKED_OUT,
  ONBOARDING_PREP,
  ONBOARDING_FINAL,
  PLACED,
];

export const MspNewSubmissionCandidateStatus = [PRE_SCREEN, CLIENT_REVIEW];

export const MspPreInterviewCandidateStatus = [APPLICANT, PRE_SCREEN, CLIENT_REVIEW];

export const ActiveCandidateStatus = [
  APPLICANT,
  PRE_SCREEN,
  CLIENT_REVIEW,
  INTERVIEW,
  OFFER_EXTENDED,
  OFFER_SUBMITTED,
  OFFER_REJECTED,
  OFFER_ACCEPTED,
];

export const OnBoardingStatus = [OFFER_ACCEPTED, ONBOARDING_PREP, ONBOARDING_FINAL];

export const PrescreenToastMessage = 'Candidate (name) Pre Screened successfully';
export const ClientReviewToastMessage = 'Candidate (name) Client Reviewed successfully';
export const RejectToastMessage = 'Candidate (name) Rejected successfully';
export const OfferExtendedToastMessage = 'Offer Extended for Candidate (name) successfully';
export const OfferSubmittedToastMessage = 'Offer Submitted for Candidate (name) successfully';
export const OfferAcceptedToastMessage = 'Offer Accepted for Candidate (name) successfully';
export const OfferRejectedToastMessage = 'Offer Rejected for Candidate (name) successfully';
export const WithdrawToastMessage = 'Candidate (name) withdrawn successfully';
export const BulkPrescreenToastMessage = 'Candidates Pre Screened successfully';
export const BulkRejectToastMessage = 'Candidates Rejected successfully';
export const BulkShortlistToastMessage = 'Candidates Shortlisted successfully';
export const OnboardToastMessage = 'Candidate (name) onboarded successfully';
export const BackOutToastMessage = 'Candidate (name) backed out successfully';
export const WithdrawOfferToastMessage = 'Offer withdrawn successfully';
export const RejectOfferToastMessage = 'Offer rejected successfully';

export const RehireOfferToastMessage = 'Contractor (name) rehire offered successfully';
export const RehireInterviewToastMessage = 'Contractor (name) rehire interviewed successfully';
export const BulkRehireOfferToastMessage = 'Rehire Offer Submitted for selected Contractor(s) successfully';
export const BulkRehireInterviewToastMessage = 'Rehire Interview Submitted for selected Contractor(s) successfully';
